let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fEAMS")).then(() => parcelRequire('6PBqm'));